import { PaymentElement } from "@stripe/react-stripe-js";
import { useState } from "react";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import { Modal, ModalBody } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

const Checkout = () => {
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();
    const stripe = useStripe();
    const elements = useElements();

    const [message, setMessage] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        setIsProcessing(true);

        const { error, paymentIntent } = await stripe.confirmPayment({
            elements,
            confirmParams: {

                return_url: `${window.location.origin}/student/session-payment`,
            },
            redirect: "if_required"
        });

        if (error) {
            setMessage(error.message);
        }
        else if (paymentIntent && paymentIntent.status === "succeeded") {
            setShowModal(true)
            setTimeout(() => {
                setShowModal(false)
                navigate('/student/dashboard');
            }, 1000);

        }
        else {
            setMessage("An unexpected error occured.");
        }

        setIsProcessing(false);
    };



    return (
        <main className="px-3 py-4  bg-light">
            <form id="payment-form" onSubmit={handleSubmit}>
                <PaymentElement id="payment-element" />
                <button disabled={isProcessing || !stripe || !elements} id="submit" className="btn btn-primary w-100 position-relative mt-5">
                    <span id="button-text">
                        {isProcessing ? "Processing ... " : "Pay now"}
                    </span>
                </button>
                {/* Show any error or success messages */}
                {message && <div id="payment-message">{message}</div>}
            </form>

            <>
                <button type="button" hidden={true} className="btn btn-primary d-none" id='modal-open-payment' data-bs-toggle="modal" data-bs-target="#exampleModal">
                    Launch demo modal
                </button>
                {/* Payment Modal */}
                <Modal
                    show={showModal} onHide={() => setShowModal(false)}
                    className="logout-modal"
                    id="paymentModal"
                    tabIndex={-1}

                >

                    <ModalBody

                        className="modal-body my-4"
                    // style={{
                    //     display: "flex",
                    //     flexDirection: "column",
                    //     alignItems: "center",
                    //     justifyContent: "center"
                    // }}
                    >
                        <img src="/assets/img/user/verified.gif" alt="" srcset="" />
                        <h4 className="mt-3">Payment succeeded!</h4>
                        <p className="text-center">
                            Your transaction was completed successfully.
                            <br />
                            Thank you for your purchase!
                        </p>
                        <Link to="/student/dashboard">
                            <button
                                type="button"
                                className="btn btn-success"
                                data-bs-dismiss="modal"
                            >
                                Go To Your Dashboard
                            </button>
                        </Link>
                    </ModalBody>

                </Modal>
            </>
        </main>
    );
}
export default Checkout